export const getEntriesByName = (mark, performance = window.performance) => {
  if (!performance || typeof performance.getEntriesByName !== 'function') {
    return undefined;
  }
  return performance.getEntriesByName(mark);
};

export const mark = (performanceMark, performance = window.performance) => {
  if (!performance || typeof performance.mark !== 'function') {
    return;
  }
  performance.mark(performanceMark);
};

export const clearMarks = (
  performanceMark,
  performance = window.performance,
) => {
  if (!performance || typeof performance.clearMarks !== 'function') {
    return;
  }
  performance.clearMarks(performanceMark);
};

export const measure = (
  measurementName,
  startMark,
  endMark,
  performance = window.performance,
) => {
  if (!performance || typeof performance.measure !== 'function') {
    return;
  }
  performance.measure(measurementName, startMark, endMark);
};
